import Axios from 'axios';
import { apiUrl } from 'app/environment-variables';
import { TemplatePageI } from './models';

type TemplateParams = {
  slug__iexact: string;
};

export const getTemplate = (params?: TemplateParams) =>
  Axios.get<CommonTypes.RestfulResponse<TemplatePageI>>(
    `${apiUrl}/template-page/`,
    { params },
  );
